const AttachFileAdd = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M720-320v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80ZM460-80q-92 0-156-64t-64-156v-420q0-66 47-113t113-47q66 0 113 47t47 113v380q0 42-29 71t-71 29q-42 0-71-29t-29-71v-380h80v380q0 8 6 14t14 6q8 0 14-6t6-14v-380q0-33-23.5-56.5T400-800q-33 0-56.5 23.5T320-720v420q0 58 41 99t99 41q58 0 99-41t41-99v-380h80v380q0 92-64 156T460-80Z"/>
        </svg>
    )
}

export default AttachFileAdd;

